import React, { FunctionComponent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useEvent } from 'features/events/eventHooks';
import { EventDate } from 'features/events/EventDate';
import { EventCountdownTimer } from 'features/events/components/EventCountdownTimer';
import { FullScreenTitle } from 'components/Layouts/FullScreenView/FullScreenTitle';
import { useAppSelector } from 'hooks/redux';

export const EventCreatorCountdown: FunctionComponent = () => {
  const { id } = useParams();
  const event = useEvent(id);
  const nativeEventStopped = useAppSelector(
    (state) => state.events.nativeEventStopped
  );

  const calculateTimeLeft = (): string | undefined => {
    return event?.durationToEvent()?.toFormat('hh:mm:ss');
  };
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [isOverdue, setIsOverdue] = useState(event?.isOverdue());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
      setIsOverdue(event?.isOverdue());
    }, 1000);
    return () => clearTimeout(timer);
  });

  if (!event) {
    return null;
  }

  if (nativeEventStopped) {
    return null;
  }

  if (event.isAdhoc()) {
    return (
      <div className="tw-text-center tw-mx-auto tw-max-w-[620px] tw-full">
        Click <strong>Start</strong> to go live
        <FullScreenTitle title={event.title} />
      </div>
    );
  }

  return (
    <div className="tw-text-center tw-mx-auto tw-max-w-[620px] tw-full">
      {!event.endedAt && <span>Next event:</span>}
      <FullScreenTitle title={event.title} />
      <EventDate eventId={event.id} hideTime={event.isIn24hrs()} />
      <div className="tw-mt-2">
        {isOverdue ? (
          <p className="tw-m-0">Event overdue, your listeners are waiting!</p>
        ) : (
          <EventCountdownTimer event={event} timeLeft={timeLeft} />
        )}
      </div>
    </div>
  );
};
